import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import './assets/less/reset.less';
// px2rem 自适应
import './utils/setHtmlFontSize.js';
// 过滤器
import filters from './utils/filters.js';
// import { SentryInit } from './utils/sentryUtils'; // 引入sentry
import SvgIcon from '@/view/components/SvgIcon'; // svg组件
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { Lazyload } from 'vant';

const app = createApp(App);
// SentryInit(app, router); // 初始化sentry
app.use(router);
app.use(store);
app.use(Lazyload, {
  loading: 'https://stor.weixinhost.com/3/wxhost-images/rf_6c4f65342a4cf6a58de2f4813d822ff5'
});

app.config.globalProperties.$filters = filters;

app.mount('#app');

app.component('svg-icon', SvgIcon);
app.component(VueQrcode.name, VueQrcode);

const req = require.context('./assets/svg', false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);